module.exports = __webpack_public_path__ + "media/mypage/images/back_to_top_btn-2e706da669b24a66d5d909a737005eaa.png";